<template>
  <page>
    <div class="order-detail-page">
      <!-- <template v-if="detailMsg.orderClassify === 1">
        <van-collapse
          v-model="activeNames"
          v-if="detailMsg.convertOrderStatus !== 0"
        >
          <van-collapse-item
            title="物流信息"
            name="1"
            disabled
            v-if="!shippingName"
          >
            <template v-if="isGroupOrder">
              <div v-if="groupStatus == 0">拼团订单，成团后发货</div>
              <div v-else-if="groupStatus == 1">待商家发货</div>
            </template>
            <div v-else>待商家发货</div>
          </van-collapse-item>
          <div class="logistics" v-else>
            <van-icon name="arrow-down" />
            <div
              class="logistics-title"
              @click="logisticsType = !logisticsType"
            >
              物流信息
              <van-icon :name="logisticsType ? 'arrow-up' : 'arrow-down'" />
            </div>
            <div class="logistics-info">
              <span>
                {{ detailMsg.orderGoodss[0].shippingName }}：
                {{ detailMsg.orderGoodss[0].skyShippingNo }}
              </span>
              <ClickCopy
                :content="`快递公司：${detailMsg.orderGoodss[0].shippingName}\n快递单号：${detailMsg.orderGoodss[0].skyShippingNo}`"
              >
                复制
              </ClickCopy>
            </div>
            <div v-if="!kdNoticeRecordList" class="van-collapse-item__content">
              暂无物流信息
            </div>
            <div class="logistics-list" v-else>
              <van-steps
                direction="vertical"
                :active="0"
                active-color="#FF3400"
              >
                <template v-if="logisticsType">
                  <van-step
                    v-for="(list, index) in kdNoticeRecordList"
                    :key="index"
                  >
                    <h3>{{ list.context }}</h3>
                    <p>{{ list.ftime }}</p>
                  </van-step>
                </template>
                <template v-else>
                  <van-step>
                    <h3>{{ kdNoticeRecordList[0].context }}</h3>
                    <p>{{ kdNoticeRecordList[0].ftime }}</p>
                  </van-step>
                </template>
              </van-steps>
            </div>
          </div>
        </van-collapse>
      </template> -->
      <div class="order-main">
        <div class="order-info one">
          <div class="order-title">
            <h3>商品信息</h3>
          </div>
          <div class="pic-box" v-for="(orderItem, index) in orderGoodss" :key="index">
            <img
              :src="orderItem.skuDto.skuThumb"
              alt=""
              @click="
                $router.push({
                  name: 'goods-detail',
                  query: { goodsId: orderItem.goodsId }
                })
              "
            />
            <div class="card-msg">
              <p
                class="card-name"
                @click="
                  $router.push({
                    name: 'goods-detail',
                    query: { goodsId: orderItem.goodsId }
                  })
                "
              >
                {{ orderItem.goodsName }}
              </p>
              <p
                class="card-num"
                @click="
                  $router.push({
                    name: 'goods-detail',
                    query: { goodsId: orderItem.goodsId }
                  })
                "
                v-if="orderGoodss.length !== 0"
              >
                ￥{{ orderItem.goodsPrice }} &nbsp;X &nbsp;{{ orderItem.goodsNum }}
              </p>
              <p class="card-date">
                <formatData class="time" :date="detailMsg.addTime * 1000" fmt="yyyy-MM-dd hh:mm" />
                <span
                  class="fr ft-14 color-orange"
                  @click="handleCustomerService(orderItem)"
                  v-if="orderItem.refundStatus !== 0"
                >
                  {{ getStauts(orderItem.refundStatus) }}
                </span>
                <span
                  style="color: #fc4c00; float: right"
                  @click="showActiveSn(orderItem)"
                  v-if="orderItem.orderClassify === 9 && orderItem.orderMovieActiveList.length"
                >
                  查看卡密
                </span>
              </p>
            </div>
          </div>

          <ul class="price-list">
            <li>
              <span>商品金额</span>
              <span class="txt-align-r">¥{{ goodsAmount }}</span>
            </li>
            <li>
              <span>运费</span>
              <span class="txt-align-r">￥{{ detailMsg.shippingFee }}</span>
            </li>
            <li>
              <span>订单总额</span>
              <span class="txt-align-r" v-if="detailMsg.payStatus === 2">¥{{ detailMsg.moneyPaid }}</span>
              <span class="txt-align-r" v-else>{{ detailMsg.orderAmount }}</span>
            </li>
          </ul>
        </div>
        <div class="order-info">
          <div class="order-title" style="display: flex; justify-content: space-between">
            <h3 style="inline-block">订单信息</h3>
            <div
              style="font-size: 15px; color: #fc4c00"
              @click="checkShipping(detailMsg)"
              v-if="detailMsg.orderClassify !== 9"
            >
              查看物流
            </div>
          </div>
          <ul class="price-list">
            <li>
              <span>订单编号</span>
              <span class="txt-align-r">{{ orderSn }}</span>
            </li>
            <li>
              <span>订单状态</span>
              <span class="txt-align-r color-orange">
                {{ detailMsg.convertOrderStatus | orderStatus }}
              </span>
            </li>
            <li>
              <span>订单时间</span>
              <span class="txt-align-r">
                <formatData :date="detailMsg.addTime * 1000" fmt="yyyy-MM-dd hh:mm" />
              </span>
            </li>
          </ul>
        </div>
        <div class="order-info">
          <div class="order-title">
            <h3>用户信息</h3>
          </div>
          <ul class="price-list">
            <li>
              <span>{{ detailMsg.consignee }} {{ detailMsg.mobile }}</span>
            </li>
            <li>
              <span>
                {{ detailMsg.provinceCn }}{{ detailMsg.cityCn }}{{ detailMsg.districtCn }}{{ detailMsg.address }}
              </span>
              <span v-if="(detailMsg.orderClassify == 3 || detailMsg.orderClassify === 4) && state == 1">
                激活账号:{{ orderGoodss[0].orderMovieActiveList[0].activeAccountType == 'weixin' ? '微信' : 'QQ' }}
                {{ orderGoodss[0].orderMovieActiveList[0].activeNickName }}
              </span>
            </li>
          </ul>
        </div>
        <div class="order-info">
          <div class="order-title">
            <h3>发票类型</h3>
          </div>
          <ul class="price-list">
            <li>
              <span>发票类型</span>
              <span class="txt-align-r">电子发票</span>
            </li>
            <li>
              <span>发票抬头</span>
              <span class="txt-align-r">{{ detailMsg.invPayee }}</span>
            </li>
          </ul>
        </div>
        <div class="submit-box">
          <!-- $router.push({
            name: 'member-activation',
            query: {
              activeSn: data[0].activeSn,
              isActive: 1
            }
          }) -->
          <van-button
            v-if="detailMsg.existInvoice"
            type="warning"
            class="submit-btn"
            @click="
              $router.push({
                name: 'order-invoice',
                query: { orderSn: orderSn }
              })
            "
          >
            查看发票
          </van-button>
          <!-- 待付款 -->
          <template v-if="detailMsg.convertOrderStatus === 0">
            <van-button type="warning" class="btn check-btn" @click="toPaying(detailMsg)">去支付</van-button>
            <van-button type="default" class="btn shopping-btn" @click="cancel">取消订单</van-button>
            <!-- <van-button type="danger" class="submit-btn">立即支付</van-button> -->
          </template>
          <!--确认收货-->
          <template v-if="detailMsg.convertOrderStatus === 3">
            <van-button
              type="danger"
              class="submit-btn"
              @click="confirmReceive(detailMsg)"
              v-if="detailMsg.orderClassify === 1"
            >
              确认收货
            </van-button>
            <van-button
              type="danger"
              class="submit-btn"
              @click="confirmReceive(detailMsg)"
              v-else-if="detailMsg.orderClassify === 2"
            >
              下载卡密
            </van-button>
            <!-- <van-button
              type="danger"
              class="submit-btn"
              @click="confirmReceive(detailMsg)"
              v-else
            >
              立即激活
            </van-button> -->
          </template>
          <template v-if="detailMsg.convertOrderStatus === 4">
            <van-button
              type="danger"
              @click="confirmReceive(detailMsg)"
              class="submit-btn"
              v-if="detailMsg.orderClassify === 2"
            >
              下载卡密
            </van-button>
          </template>
          <!-- <van-button type="danger"  @click="submitOrder" class="submit-btn">{{detailMsg.convertOrderStatus| orderStatus}}</van-button> -->
          <!-- <div>
            <van-button type="warning" class="btn check-btn" @click="toPaying">去支付</van-button>
            <van-button type="default" class="btn shopping-btn" @click="cancel">取消订单</van-button>
          </div> -->
        </div>
        <van-overlay :show="showGetWay" @click="showGetWay = false" class="dialog-box">
          <div class="wrapper get-way-wrapper" @click.stop>
            <h3 class="get-way-title">请选择获取方式</h3>
            <p style="text-align: center; color: #e64340ff; font-size: 12px; margin-top: 29px">
              此文件为加密文件，文件密码为订单后6位
            </p>
            <van-button type="default" @click="handleSendEmail" class="get-way-btn btn2">
              发送至我的邮箱
            </van-button>
            <!-- <van-button
              type="danger"
              @click="cardCreateUserToken"
              class="get-way-btn btn1"
            >
              本地下载
            </van-button> -->
          </div>
        </van-overlay>
        <van-overlay :show="showSend">
          <div class="wrapper wrapper-box" @click.stop>
            <h3 class="email-title">请输入您的邮箱地址</h3>
            <van-field type="email" class="email-input" border v-model="email" placeholder="邮箱地址" />
            <p style="text-align: center; color: #e64340ff; font-size: 12px">
              此文件为加密文件，文件密码为订单后6位
            </p>
            <van-button type="default" @click="handleCancelSend" class="dialog-btn btn2">取消</van-button>
            <van-button type="danger" @click="handleConfirmSendEmail" class="dialog-btn btn1">确认</van-button>
          </div>
        </van-overlay>
      </div>
    </div>
  </page>
</template>
<script>
import { Dialog } from 'vant'
import formatData from '@/components/formatData'
import ClickCopy from '@/components/ClickCopy'
import { mapActions } from 'vuex'
export default {
  components: {
    formatData,
    ClickCopy
  },
  data() {
    return {
      groupStatus: null,
      isGroupOrder: false,
      shippingName: null,
      skyShippingNo: null,
      logisticsType: false,
      email: '',
      showGetWay: false,
      showSendEmail: false,
      showSend: false,
      showExpress: false,
      activeNames: ['1'],
      active: 0,
      hasCompleted: false,
      pageNum: 1,
      pageSize: 10,
      orderStatus: 0,
      orderSn: null,
      goodsId: '',
      state: '',
      orderGoodsId: '', // 退款时ID
      // orderGoodsAmount: null,
      goodsAmount: null,
      detailMsg: {},
      skuDto: {},
      isApply: true,
      orderGoodss: [],
      kdNoticeRecordList: null, // 快递接口
      shippingStatus: 0, // 0未发货 1是已发货
      orderClassify: null, // convertOrderStatus 为3的时候再判断一层 订单类别 1为实物订单，2为虚拟卡，3为激活权益, 4：线上会员 orderClassify2,3,4显示物流
      tabs: [
        {
          title: '全部'
        },
        {
          title: '待付款'
        },
        {
          title: '待发货'
        },
        {
          title: '待收货'
        },
        {
          title: '已收货'
        }
      ],
      orderTime: null,
      backRefundDto: null,
      sourceFlag: '',
      groupCode: null
    }
  },
  methods: {
    checkShipping(data) {
      let shippingNoList = []
      data.orderGoodss.forEach((item) => {
        if (!shippingNoList.includes(item.shippingNo) && item) {
          shippingNoList.push(item.shippingNo)
        }
      })
      let goods = []
      data.orderGoodss.forEach((ele) => {
        if (ele.goodsId === ele.skuDto.id) {
          goods.push({
            shippingNo: ele.shippingNo,
            skuName: ele.skuDto.skuName
          })
        }
      })
      goods = JSON.stringify(goods)
      shippingNoList.join(',')
      if (shippingNoList != '') {
        this.$router.push({
          name: 'track-logistics',
          query: { nu: shippingNoList, goods: goods, orderCode: data.orderCode }
        })
      } else {
        this.$toast('暂无物流单号！')
      }
    },
    // ...mapActions(['setEventTracking']),
    getStauts(stauts, type) {
      const refundStatus = {
        1: '申请退货',
        2: '申请换货',
        3: '申请退款',
        4: '申请售后',
        5: '售后中',
        6: '售后已完成'
      }
      return refundStatus[stauts]
    },
    // 调取支付相关
    toPaying(obj) {
      let params = {}
      params = obj
      // this.setEventTracking({
      //   vm: this,
      //   orderNo: params.orderCode
      // })
      this.$service
        .webPay({
          merger: false,
          orderAmount: params.orderAmount,
          orderSn: params.orderCode,
          payWay: this.$getBrowser(),
          returnUrl: window.location.origin + '/pay-success?orderSn=' + params.orderCode
        })
        .then((res) => {
          window.location = res.data
        })
    },
    // 取消订单
    cancel() {
      this.$service.cancelOrder({ orderSn: this.orderSn }).then((res) => {
        if (res.message === 'SUCCESS') {
          this.$toast('取消成功！')
          this.$router.push({
            name: 'my-order',
            query: { orderSn: this.orderSn, goodsId: this.goodsId }
          })
        }
      })
    },
    // 确认收货
    confirmReceive(obj) {
      if (obj.orderClassify === 1) {
        this.$dialog
          .confirm({
            message: '请确认是否已经到货？'
          })
          .then(() => {
            console.log(obj, '??????')
            this.$service
              .confirmReceived({
                orderCode: obj.orderCode,
                sourceFlag: this.sourceFlag,
                tenantId: obj.platformCode
              })
              .then((res) => {
                if (res.message === 'SUCCESS') {
                  this.$toast('确认收货成功！')
                  location.reload()
                  // this.$router.push({ name: 'my-order', query: { orderSn: this.orderSn, goodsId: this.goodsId } })
                }
              })
          })
          .catch(() => {})
      } else if (obj.orderClassify === 3 || obj.orderClassify === 4) {
        // // 激活相关
        // this.$service
        //   .immeActiveGetActiveSn({
        //     orderSn: this.orderSn
        //   })
        //   .then(res => {
        //     const data = res.data
        //     this.$router.push({
        //       name: 'member-activation',
        //       query: {
        //         activeSn: data[0].activeSn,
        //         isActive: 1
        //       }
        //     })
        //   })
        // // this.orderSn = item.orderSn
      } else {
        // 卡密相关
        this.showGetWay = true
      }
    },
    // 查询拼团状态
    // TODO
    // async getGroupDetail () {
    //   let res = await this.$service.actGroupBuyDetail({
    //     orderSn: this.orderSn || '',
    //     groupCode: this.groupCode || '',
    //     isOrderDetails: true
    //   })
    //   let groupDetails = res.data
    //   this.isGroupOrder = !!groupDetails
    //   if (groupDetails) {
    //     this.groupStatus = groupDetails.status
    //   }
    // },
    getOrderInfo() {
      this.$service
        .getOrderInfo({
          orderCode: this.orderSn,
          sourceFlag: this.sourceFlag
        })
        .then((res) => {
          const data = res.data
          console.log('datadatadata', data)
          const orderGoodss = data.orderGoodss
          this.detailMsg = data
          this.shippingName = orderGoodss[0].shippingName
          this.skyShippingNo = orderGoodss[0].skyShippingNo
          this.orderGoodss = orderGoodss
          this.goodsAmount = data.goodsAmount // 商品金额
          this.skuDto = orderGoodss[0].skuDto
          // TODO
          if (orderGoodss && orderGoodss[0].orderMovieActiveList[0]) {
            this.state = orderGoodss[0].orderMovieActiveList[0].state
          }
          this.shippingStatus = data.shippingStatus
          this.orderClassify = data.orderClassify
          this.backRefundDto = orderGoodss[0].backRefundDto
          // this.orderGoodsId = res.data.orderGoodss[0].orderGoodsId
          if (this.shippingStatus === 0) {
            this.showExpress = false
            return false
          }
          // 1为实物订单，2为虚拟卡，3为激活权益, 4：线上会员
          if (this.orderClassify !== 1) {
            this.showExpress = true
            this.getKdData(data)
          }
          if (data.convertOrderStatus !== 0 || data.convertOrderStatus !== 1 || data.convertOrderStatus !== 2) {
            if (data.orderClassify === 1) {
              this.showExpress = true
              this.getKdData(data)
            } else {
              this.showExpress = false
            }
          }
          const date = new Date().getTime()
          if (data.confirmTime > 0) {
            if ((date - data.confirmTime * 1000) / 86400000 > 15) {
              // 获取确认收货的时间，确认收货后超过15天，售后入口关闭
              this.isApply = false
            }
          }
        })
    },
    // 申请退款和申请售后
    handleCustomerService(item) {
      if (item.orderClassify === 0 || item.orderClassify === 1) {
        const refundStatus = item.refundStatus
        if (refundStatus == 3 && this.isGroupOrder) {
          // 拼团订单,退款时taost
          this.$toast('拼团结束后,可退款')
          return
        }
        if (refundStatus !== 5 && refundStatus !== 6) {
          this.$router.push({
            name: refundStatus === 4 ? 'choice-type' : 'back-order',
            query: {
              orderSn: this.orderSn,
              type: this.$route.query.type,
              stauts: refundStatus,
              orderGoodsId: item.id,
              sourceFlag: this.sourceFlag
            }
          })
        } else {
          this.$router.push({
            name: 'back-order-detail',
            query: { orderGoodsId: item.id }
          })
        }
      } else {
        this.$toast('该商品暂时不支持售后!')
      }
    },
    // 查看售后
    toBackOrderDetail(item) {
      console.log('item', item)
      this.$router.push({
        name: 'back-order-detail',
        query: { orderGoodsId: item.orderGoodsId }
      })
    },
    getKdData(res) {
      // 1为实物订单，2为虚拟卡，3为激活权益, 4：线上会员
      const data = res.orderGoodss
      this.$service
        .getKdData({
          nu: data[0].skyShippingNo,
          com: data[0].postcode,
          orderCode: res.orderCode
        })
        .then((res) => {
          if (res.data) {
            this.kdNoticeRecordList = res.data.kdNoticeRecordList
          }
        })
    },
    handleSendEmail() {
      this.showGetWay = false
      this.showSend = true
    },
    // 下载卡密之前获取token
    // cardCreateUserToken () {
    //   this.$service
    //     .cardCreateUserToken({
    //       orderSn: this.orderSn
    //     })
    //     .then(res => {
    //       if (res.data) {
    //         let userToken = res.data
    //         this.downloadNative(userToken)
    //       }
    //     })
    // },
    // 下载卡密
    // downloadNative (userToken) {
    //   // this.userToken = 'b9121b3a6b09e9c164e009239bfd48c7'
    //   const url =
    //     '/mini-program-server/api/order/v1/downloadVirtualCardExcel?userToken=' +
    //     userToken
    //   let api = process.env.VUE_APP_TITLE === 'production' ? url : `/api${url}`
    //   window.location.href = api
    // },
    handleCancelSend() {
      this.showSend = false
      this.showGetWay = true
    },
    handleConfirmSendEmail() {
      // this.orderSn = 'F190905145349129q5'
      var reg = new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$')
      if (this.email === '') {
        return this.$toast('请输入邮箱')
      }
      if (!reg.test(this.email)) {
        return this.$toast('请输入正确的邮箱')
      }
      this.showSend = true
      // this.$service
      //   .sendEmailVirtualCardExcel({ email: this.email, orderSn: this.orderSn })
      //   .then(res => {
      //     if (res.code === 200) {
      //       this.$toast('已发送至您的邮箱，请注意查收！')
      //       this.showSend = false
      //     }
      //   })
    },
    showActiveSn(data) {
      Dialog.alert({
        title: '查看卡密',
        message: `卡号：${data.orderMovieActiveList[0].activeSn}\n 卡密：${data.orderMovieActiveList[0].activeKey}`,
        theme: 'round-button'
      }).then(() => {
        // on close
      })
    }
  },
  created() {
    this.orderSn = this.$route.query.orderSn
    this.sourceFlag = this.$route.query.sourceFlag
    this.getOrderInfo()
    // this.getGroupDetail()
  },
  filters: {
    orderStatus(val) {
      switch (val) {
        case 0:
          return '待付款'
        case 1:
          return '已付款'
        case 2:
          return '待发货'
        case 3:
          return '待收货'
        case 4:
          return '已收货'
        case 5:
          return '售后中'
        case 6:
          return '已完成售后'
        case 7:
          return '售后申请驳回'
        default:
          return ' '
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.logistics {
  background: #ffffff;
  padding-left: 15px;

  .logistics-title {
    height: 44px;
    line-height: 44px;
    border-bottom: #F8F8F8 1px solid;
    font-size: 14px;
    padding-right: 15px;

    .van-icon {
      float: right;
      height: 24px;
      width: 24px;
      line-height: 24px;
      text-align: center;
      margin-top: 10px;
      font-size: 18px;
    }
  }

  .logistics-info {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    border-bottom: #E5E5E5 1px solid;
  }

  .logistics-list {
    padding-right: 15px;
  }
}

h3, p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.order-detail-page {
  background: #efeff4;
  width: 100%;
  overflow: hidden;
  padding-bottom: 44px;
}

.order-main .order-info {
  margin-top: 10px;
  background: #ffffff;
  width: 100%;
  overflow: hidden;
}

.order-main .one {
  margin-top: 0;
}

.order-title {
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  border-bottom: 1px solid #E5E5E5;
}

.order-title h3 {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.pic-box {
  height: 79px;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e5e5;
}

.pic-box img {
  width: 80px;
  height: 80px;
  float: left;
  background: #eee;
}

.pic-box .card-msg {
  margin-left: 10px;
  float: left;
  width: 255px;
  position: relative;
  height: 80px;
}

.card-msg .card-name {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}

.card-msg .card-num {
  color: #666;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
}

.card-msg .card-date {
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

.card-msg .card-date .time {
  color: #999;
  float: left;
}

.card-msg .card-date .pic-price {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  float: right;
}

.price-list li {
  height: 43px;
  line-height: 43px;
  border-bottom: 1px solid #E5E5E5;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}

.price-list span {
  flex: 1;
  color: #999;
  font-size: 14px;
}

.txt-align-r {
  text-align: right;
}

.submit-box {
  text-align: center;
  margin-top: 40px;
}

.submit-box .submit-btn {
  width: 335px;
  background: #FF3400;
  border-radius: 8px 8px;
}

.btn {
  width: 157.5px;
  height: 45px;
  border-radius: 8px 8px;
}

.submit-box .check-btn {
  background: #FF3400;
  color: #ffffff;
}

.submit-box .shopping-btn {
  background: #ffffff;
  color: #FF3400;
  border: none;
  margin-left: 15px;
}

.color-orange {
  color: #FC4C00 !important;
}

.refund-btn {
  float: right;
}

.get-way-wrapper .get-way-title {
  margin-bottom: 10px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
  padding-top: 50px;
}

.dialog-box .dialogTitle {
  margin: 50px 0 29px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
}

.dialog-box .dialogTest {
  color #E64340FF {
    font-size: 12px;
    text-align: center;
  }
}

.email-title {
  margin: 30px 0 10px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
}

.email-input {
  width: 258px;
  height: 44px;
  background: #F8F8F8FF;
  margin: 0 auto 10px;
}

.wrapper-box, .get-way-wrapper {
  height: 197px;
  width: 335px;
  margin: 55% auto 0;
  background: #fff;
}

.wrapper-box .email-title {
  padding-top: 20px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
}

.get-way-btn {
  width: 150px;
  height: 47px;
  text-align: center;
  border-radius: 5px;
  margin-top: 14px;
}

.dialog-btn {
  width: 150px;
  height: 47px;
  text-align: center;
  border-radius: 5px;
  margin-top: 14px;
}

.btn1 {
  background: #FF5E27FF;
  color: #ffffff;
}

.btn2 {
  color: #FF5E27FF;
  margin: 0 5px 0 15px;
}
</style>
